module.exports = __webpack_public_path__ + "static/img/premier_league.9abe63f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/bg/premier_league.jpg
// module id = YhU6
// module chunks = 1